<template>
  <div class="courselist">
    <div class="banner_container">
      <div class="banner_title">相关查询</div>
      <img
        src="~@/assets/images/listitem/相关查询- banner@2x.png"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
    <div class="container_wrap">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="eltab"
      >
        <el-tab-pane
          :label="item2.name"
          :name="item2.name"
          v-for="(item2, index2) in secondNav"
          :key="index2"
        >
          <div class="tabpane_container tabpane_container_act">
            <div class="form_content">
              <el-form
                label-position="right"
                label-width="149px"
                :model="formLabelAlign"
              >
                <el-form-item label="姓名">
                  <el-input
                    v-model="formLabelAlign.name"
                    class="inputclass"
                    clearable
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                  <el-input
                    v-model="formLabelAlign.num"
                    class="inputclass"
                    clearable
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
                <el-form-item label="等级">
                  <el-select
                    v-model="formLabelAlign.grade"
                    :placeholder="'请选择等级'"
                    class="inputclass"
                    clearable
                  >
                    <el-option
                      :label="value"
                      :value="value"
                      v-for="(value, key, index) in applyGradeArr"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在城市">
                  <!-- <el-select
                    v-model="formLabelAlign.province"
                    placeholder="请选择所在城市"
                    class="inputclass"
                    clearable
                  >
                    <el-option
                      :label="value"
                      :value="value"
                      v-for="(value, key, index) in areaOptions.province_list"
                      :key="index"
                    ></el-option>
                  </el-select> -->

                  <el-cascader
                    :options="areaOptions"
                    :props="{ label: 'title' }"
                    @change="handleAreaChange"
                    clearable
                    class="inputclass"
                  ></el-cascader>
                </el-form-item>
                <el-form-item>
                  <div class="formBtn" @click="onSubmit">查询</div>
                  <div class="btn_tips">*输入任何一项 均可查询</div>
                </el-form-item>
              </el-form>
            </div>
            <div class="default_right_pic" v-if="searchReault == -1"></div>
            <div class="search_result" v-if="searchReault != -1">
              <template v-if="searchReault == 1">
                <div
                  class="search_result_item"
                  v-for="(item, index) in queryResultArr"
                  :key="index"
                >
                  <!-- ~@/assets/images/listitem/pic-资质查询-儿童照片@2x.png -->
                  <!-- require('@/assets/images/listitem/pic-资质查询-儿童照片@2x.png') -->
                  <!-- default_face.png -->
                  <img
                    :src="
                      item.pics && item.pics.length
                        ? item.pics[0].url
                        : require('@/assets/images/listitem/default_face.png')
                    "
                    class="left_pic"
                  />
                  <div class="right_content">
                    <div class="right_content_wrap">
                      <div class="right_content_leftdata">
                        <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div class="right_content_line_item_title">
                              姓名
                            </div>
                            <div class="right_content_line_item_cont">
                              {{ item.name }}
                            </div>
                          </div>
                        </div>
                        <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div class="right_content_line_item_title">
                              等级
                            </div>
                            <div class="right_content_line_item_cont">
                              {{ item.grade }}
                            </div>
                          </div>
                        </div>
                        <div class="right_content_line" v-if="item.status == 6">
                          <div class="right_content_line_item">
                            <div class="right_content_line_item_title">
                              授证时间
                            </div>
                            <div class="right_content_line_item_cont">
                              {{ item.grant_time | yearForm }}-
                              {{ item.grant_time | monthForm }}-
                              {{ item.grant_time | dayForm }}
                            </div>
                          </div>
                        </div>
                        <div class="right_content_line" v-if="item.danwei">
                          <div class="right_content_line_item">
                            <div class="right_content_line_item_title">
                              所属单位
                            </div>
                            <div class="right_content_line_item_cont">
                              {{ item.danwei }}
                            </div>
                          </div>
                        </div>
                        <!-- <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div class="right_content_line_item_title">
                              考级情况
                            </div>
                            <div class="right_content_line_item_cont">
                              一级(2019-12-12)
                            </div>
                          </div>
                        </div>
                        <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div class="right_content_line_item_title"></div>
                            <div class="right_content_line_item_cont">
                              二级(2020-12-12)
                            </div>
                          </div>
                        </div> -->
                      </div>
                      <div class="right_content_rightdata">
                        <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div
                              class="
                                right_content_line_item_title
                                right_content_line_item_title_right
                              "
                            >
                              身份证号码
                            </div>
                            <div
                              class="
                                right_content_line_item_cont
                                right_content_line_item_cont_right
                              "
                            >
                              {{ item.num | identityFilter }}
                            </div>
                          </div>
                        </div>
                        <div class="right_content_line" v-if="item.status == 6">
                          <div class="right_content_line_item">
                            <div
                              class="
                                right_content_line_item_title
                                right_content_line_item_title_right
                              "
                            >
                              证书编号
                            </div>
                            <div
                              class="
                                right_content_line_item_cont
                                right_content_line_item_cont_right
                              "
                            >
                              {{ item.code }}
                            </div>
                          </div>
                        </div>
                        <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div
                              class="
                                right_content_line_item_title
                                right_content_line_item_title_right
                              "
                            >
                              加入时间
                            </div>
                            <div
                              class="
                                right_content_line_item_cont
                                right_content_line_item_cont_right
                              "
                            >
                              {{ item.create_time | yearForm }}-
                              {{ item.create_time | monthForm }}-
                              {{ item.create_time | dayForm }}
                            </div>
                          </div>
                        </div>
                        <!-- <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div
                              class="right_content_line_item_title right_content_line_item_title_right"
                            >
                              参演作品
                            </div>
                            <div
                              class="right_content_line_item_cont right_content_line_item_cont_right"
                            >
                              《童星闪闪》
                            </div>
                          </div>
                        </div> -->
                        <!-- <div class="right_content_line">
                          <div class="right_content_line_item">
                            <div
                              class="right_content_line_item_title right_content_line_item_title_right"
                            ></div>
                            <div
                              class="right_content_line_item_cont right_content_line_item_cont_right"
                            >
                              《童星闪闪2》
                            </div>
                          </div>
                        </div> -->
                        <div class="right_content_line" v-if="item.type">
                          <div class="right_content_line_item">
                            <div
                              class="
                                right_content_line_item_title
                                right_content_line_item_title_right
                              "
                            >
                              资质标签
                            </div>
                            <div
                              class="
                                right_content_line_item_cont
                                right_content_line_item_cont_right
                              "
                            >
                              {{ item.type | typeFilter }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="right_content_lastline"
                      v-if="
                        item.QuestionCount == 3
                          ? item.rightQuestionCount == 3
                            ? 100
                            : item.rightQuestionCount * 30
                          : item.rightQuestionCount * 5
                      "
                    >
                      <div class="right_content_line">
                        <div
                          class="right_content_line_item"
                          v-if="activeName == '成绩查询'"
                        >
                          <div class="right_content_line_item_title">得分</div>
                          <div class="right_content_line_item_cont">
                            {{
                              item.QuestionCount == 3
                                ? item.rightQuestionCount == 3
                                  ? 100
                                  : item.rightQuestionCount * 30
                                : item.rightQuestionCount * 5
                            }}
                          </div>
                        </div>

                        <!-- <div class="right_content_line_item" v-else>
                          <div class="right_content_line_item_title">
                            取得荣誉
                          </div>
                          <div class="right_content_line_item_cont">
                            2019获取“最佳小演员”奖项
                          </div>
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div
                class="search_result_nonthing"
                v-if="searchReault == 0"
              ></div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <DeBounce
      :fetch-fun="DeBounceFetchData"
      :pagefetchflag="pagefetchflag"
    ></DeBounce>
  </div>
</template>
<script>
import DeBounce from "@/components/DeBounce";
// import areaOptions from "@/utils/area";
export default {
  name: "CmsQualificationsSearch",
  data() {
    return {
      areaOptions: [],
      activeName: "少儿艺术表演等级",
      searchdata: "", //搜索框
      formLabelAlign: {
        //表单数据
        name: "",
        num: "",
        grade: "",
        province: "",
        city: "",
        p: 1,
        step: 20,
      },
      searchReault: -1, //-1表示默认   0表示没有搜索到结果   1显示搜索的结果
      queryResultArr: [],
      secondNav: [
        { name: "少儿艺术表演等级" },
        { name: "艺术导师等级" },
        { name: "各类人才库" },
        { name: "成绩查询" },
        { name: "演员公会" },
      ],
      applyGradeArr: [
        "一级",
        "二级",
        "三级",
        "四级",
        "五级",
        "六级",
        "七级",
        "八级",
      ],
      pagefetchflag: true,
    };
  },
  mounted() {
    this.getAreaTreeFun();
  },
  methods: {
    handleAreaChange(value) {
      // console.log(value);
      if (value&&value.length==2) {
        this.formLabelAlign.province = value[0]
        this.formLabelAlign.city = value[1]
      }else{
        this.formLabelAlign.province = ""
        this.formLabelAlign.city = ""
      }
    },
    getAreaTreeFun() {
      this.$api.get(
        "/api/utils/areaTree",
        {},
        (res) => {
          this.areaOptions = res.data;
          this.handleAreaOptionsLen();
        },
        (err) => {
          console.log(err);
        }
      );
    },
    handleAreaOptionsLen() {
      this.areaOptions.some((item1) => {
        item1.value = item1.title;
        if (item1.children) {
          item1.children.some((item2) => {
            item2.value = item2.title;
            if (item2.children) {
              delete item2.children;
            }
          });
        }
      });
    },
    DeBounceFetchData() {
      this.onSubmit();
    },
    //tab点击事件
    handleClick() {
      //初始化数据
      this.pagefetchflag = true;
      this.searchReault = -1;
      this.formLabelAlign = {
        name: "",
        num: "",
        grade: "",
        province: "",
        city:"",
        p: 1,
        step: 20,
      };
      this.queryResultArr = [];

      if (this.activeName == "少儿艺术表演等级") {
        this.formLabelAlign.identity = 1;
        this.applyGradeArr = [
          "一级",
          "二级",
          "三级",
          "四级",
          "五级",
          "六级",
          "七级",
          "八级",
        ];
        return;
      } else if (this.activeName == "艺术导师等级") {
        this.formLabelAlign.identity = 2;
        this.applyGradeArr = ["铜牌导师", "银牌导师", "金牌导师", "钻石导师"];
        return;
      } else if (
        this.activeName == "各类人才库" ||
        this.activeName == "成绩查询"
      ) {
        this.applyGradeArr = [
          "一级",
          "二级",
          "三级",
          "四级",
          "五级",
          "六级",
          "七级",
          "八级",
          "铜牌导师",
          "银牌导师",
          "金牌导师",
          "钻石导师",
        ];
      } else if (this.activeName == "演员公会") {
        this.formLabelAlign.type = 1;
        this.applyGradeArr = [
          "一级",
          "二级",
          "三级",
          "四级",
          "五级",
          "六级",
          "七级",
          "八级",
        ];
      }
    },
    //表单提交
    onSubmit() {
      if (!this.pagefetchflag) {
        //本页数据已经加载完毕
        this.formLabelAlign.p = 1;
      }
      var emptyFlag = 0;
      for (var key in this.formLabelAlign) {
        if (
          this.formLabelAlign[key] != "" &&
          key != "type" &&
          key != "_pspt" &&
          key != "p" &&
          key != "step" &&
          key != "identity"
        ) {
          emptyFlag = 1;
        }
      }
      if (!emptyFlag) {
        // this.$message.warning("输入项为空！");
        return;
      }

      // console.log(this.formLabelAlign);
      if (
        this.activeName == "少儿艺术表演等级" ||
        this.activeName == "艺术导师等级"
      ) {
        this.fetchApplyGradeData();
      } else if (
        this.activeName == "各类人才库" ||
        this.activeName == "演员公会"
      ) {
        this.fetchRencaikuData();
      } else if (this.activeName == "成绩查询") {
        this.fetchAchievementFun();
      }
    },
    fetchApplyGradeData() {
      this.$api.post(
        "/api/kaoji/queryKaojiList",
        this.formLabelAlign,
        (res) => {
          if (this.formLabelAlign.p == 1) {
            this.queryResultArr = res.data;
            // this.$message.success("查询成功！");
          } else {
            if (res.data && res.data.length < this.formLabelAlign.step) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            this.queryResultArr = this.queryResultArr.concat(res.data);
          }
          if (this.queryResultArr.length > 0) {
            this.searchReault = 1;
          } else {
            this.searchReault = 0;
          }
          if (this.pagefetchflag) {
            this.formLabelAlign.p += 1;
          }
        }
      );
    },
    fetchRencaikuData() {
      this.$api.get(
        "/api/rencaiku/queryRencaikuList",
        this.formLabelAlign,
        (res) => {
          // this.queryResultArr = res.data;

          if (this.formLabelAlign.p == 1) {
            this.queryResultArr = res.data;
            // this.$message.success("查询成功！");
          } else {
            if (res.data && res.data.length < this.formLabelAlign.step) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            this.queryResultArr = this.queryResultArr.concat(res.data);
          }
          if (this.queryResultArr.length > 0) {
            this.searchReault = 1;
          } else {
            this.searchReault = 0;
          }
          if (this.pagefetchflag) {
            this.formLabelAlign.p += 1;
          }
          this.queryResultArr.some((item) => {
            item.name = item.ldname;
          });
        },
        (err) => {
          console.log(err);
        }
      );
    },
    // fetchresultFun() {
    //   this.$api.get(
    //     "/api/kaoji/applylist",
    //     this.formLabelAlign,
    //     (res) => {
    //       // this.queryResultArr = res.data;

    //       if (this.formLabelAlign.p == 1) {
    //         this.queryResultArr = res.data;
    //         this.$message.success("查询成功！");
    //       } else {
    //         if (res.data && res.data.length < this.formLabelAlign.p) {
    //           this.pagefetchflag = false;
    //           this.$message.success("已加载全部！");
    //         }
    //         this.queryResultArr = this.queryResultArr.concat(res.data);
    //       }
    //       if (this.queryResultArr.length > 0) {
    //         this.searchReault = 1;
    //       } else {
    //         this.searchReault = 0;
    //       }
    //       if (this.pagefetchflag) {
    //         this.formLabelAlign.p += 1;
    //       }
    //     },
    //     (err) => {
    //       console.log(err);
    //     }
    //   );
    // },
    fetchAchievementFun() {
      this.$api.get(
        "/api/kaoji/queryResultList",
        this.formLabelAlign,
        (res) => {
          // this.queryResultArr = res.data;
          // if (this.queryResultArr.length > 0) {
          //   this.searchReault = 1;
          // } else {
          //   this.searchReault = 0;
          // }
          // this.$message.success("查询成功！");
          if (this.formLabelAlign.p == 1) {
            this.queryResultArr = res.data;
            // this.$message.success("查询成功！");
          } else {
            if (res.data && res.data.length < this.formLabelAlign.step) {
              this.pagefetchflag = false;
              // this.$message.success("已加载全部！");
            }
            this.queryResultArr = this.queryResultArr.concat(res.data);
          }
          if (this.queryResultArr.length > 0) {
            this.searchReault = 1;
          } else {
            this.searchReault = 0;
          }
          if (this.pagefetchflag) {
            this.formLabelAlign.p += 1;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
  components: {
    DeBounce,
  },
  filters: {
    idFilter(value) {
      var targetstr = value.toString();
      for (let i = targetstr.length; i < 6; i++) {
        targetstr = "0" + targetstr;
      }
      return "EAE" + targetstr;
    },
    identityFilter(value) {
      if (!value) {
        return "";
      }
      return value.slice(0, 8) + "********" + value.slice(16);
    },
    typeFilter(value) {
      if (!value) {
        return "";
      }
      switch (value) {
        case 1:
          return "演员公会";
        case 2:
          return "童星库";
        case 3:
          return "艺术导师(评委)库";
        default:
          return "专业人才库";
      }
    },
  },
  watch: {
    // formLabelAlign: {
    //   handler(newValue, oldValue) {
    //     if (newValue.p!=1) {
    //       this.formLabelAlign.p=1;
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped lang="scss">
.courselist {
  // min-height: 1600px;
  background: #f4faff;
}
.banner_container {
  max-height: 318px;
  width: 100%;
  background: #f4faff;
  position: relative;
  .banner_title {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 1240px;
    font-size: 48px;
    font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
      "\5FAE\8F6F\96C5\9ED1";
    font-weight: 400;
    color: #ffffff;
  }
}
.container_wrap {
  background: #f4faff;
  // min-height: 1600px;
}
.eltab {
  width: 1240px;
  // min-height: 1600px;
  margin: 0 auto;
  margin-top: -65px;
  /deep/.el-tabs__header {
    margin: 0;
    border: none;
    /deep/.el-tabs__nav-wrap {
      padding-left: 0;
      //   调节阴影的显示
      width: 1260px;
      /deep/.el-tabs__nav-scroll {
        /deep/.el-tabs__nav {
          border: none;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          /deep/.el-tabs__item {
            box-shadow: none;
            width: 240px;
            height: 89px;
            background: #ff8d3a;
            box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
            border-radius: 32px 32px 0px 0px;
            font-size: 24px;
            font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
              "\5FAE\8F6F\96C5\9ED1";
            font-weight: 500;
            color: #ffffff;
            line-height: 89px;
            text-align: center;
            margin-right: 10px;
            border-left: none;
            &:last-child {
              margin-right: 0;
            }
          }
          /deep/.is-active {
            height: 107px;
            line-height: 127px;
            background: #ffffff;
            color: #333333;
            box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
  /deep/.el-tabs__content {
    width: 1240px;
  }
  .tabpane_container {
    width: 1240px;
    min-height: 1031px;
    background: #ffffff;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 48px 48px;
    overflow: hidden;
  }
  .tabpane_container_act {
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    .form_content {
      margin: 32px 0 0 24px;
      width: 421px;
      height: 383px;
      background: #fff4ed;
      border-radius: 30px;
      padding: 31px 0 0 16px;
      .inputclass {
        width: 240px;
        height: 40px;
      }
      /deep/.el-form-item__label {
        font-size: 16px;

        font-weight: 400;
        color: #000000;
        padding: 0 21px 0 0;
      }
      .formBtn {
        display: inline-block;
        width: 95px;
        height: 40px;
        line-height: 40px;
        background: #ff8d3a;
        border-radius: 10px;
        text-align: center;
        margin: 10px 4px 0 0;

        font-size: 14px;

        font-weight: 400;
        color: #ffffff;
        &:hover {
          opacity: 0.95;
          font-weight: bold;
          cursor: pointer;
        }
      }
      .btn_tips {
        display: inline-block;
        font-size: 14px;

        font-weight: 400;
        color: #c8c9cc;
      }
    }
    .default_right_pic {
      width: 446px;
      height: 240px;
      background: red;
      margin: 109px 0 0 152px;
      // background: url("~@/assets/imgaes/listitem/") no-repeat center center;
      background: url("~@/assets/images/listitem/pic-相关查询-默认页图@2x.png")
        no-repeat;
      background-size: 100% 100%;
    }
    .search_result {
      margin: 32px 0 0 32px;
      .search_result_item {
        width: 723px;
        background: #f2f7ff;
        border-radius: 30px;
        margin: 0 0 32px 0;
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        padding: 16px 0 16px 20px;
        .left_pic {
          width: 100px;
          height: 120px;
          object-fit: cover;
          border-radius: 8px;
        }
        .right_content {
          width: 559px;
          margin: 0 0 0 16px;
          .right_content_wrap {
            width: 100%;
            display: flex;
            flex-direction: row;
            .right_content_leftdata {
              flex: 1.1;
            }
            .right_content_rightdata {
              flex: 1;
            }
          }
          .right_content_lastline {
            width: 100%;
          }
          .right_content_line {
            flex: 1;
            height: 51px;
            display: flex;
            flex-direction: row;
            align-items: center;
            border-bottom: 1px dashed #e5e5e5;
            box-sizing: border-box;
            .right_content_line_item {
              flex: 1;
              display: flex;
              flex-direction: row;
              .right_content_line_item_title {
                width: 122px;
                height: 20px;
                font-size: 14px;

                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align: left;
              }
              .right_content_line_item_title_right {
                width: 100px;
              }
              .right_content_line_item_cont {
                text-align: left;
                height: 20px;
                font-size: 14px;

                font-weight: 400;
                color: #333333;
                line-height: 20px;
              }
            }
          }
        }
      }
      .search_result_nonthing {
        width: 395px;
        height: 395px;
        background: url("~@/assets/images/listitem/pic-zihzisearch-none@2x.png")
          no-repeat center center;
        background-size: 100% auto;
        margin-left: 156px;
      }
    }
  }
}

/deep/.eltab {
  width: 1240px;
  margin: 0 auto;
  margin-top: -65px;
  /deep/.el-tabs__header {
    margin: 0;
    border: none;
    /deep/.el-tabs__nav-wrap {
      padding-left: 0;
      /deep/.el-tabs__nav-scroll {
        /deep/.el-tabs__nav {
          border: none;
          display: flex;
          align-items: flex-end;
          /deep/.el-tabs__item {
            box-shadow: none;
            width: 240px;
            height: 89px;
            background: #ff8d3a;
            box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
            border-radius: 32px 32px 0px 0px;
            font-size: 24px;
            font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
              "\5FAE\8F6F\96C5\9ED1";
            font-weight: 500;
            color: #ffffff;
            line-height: 89px;
            text-align: center;
            margin-right: 16px;
            border-left: none;
          }
          /deep/.is-active {
            height: 107px;
            line-height: 127px;
            background: #ffffff;
            color: #333333;
            box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
          }
        }
      }
    }
  }
  /deep/.el-tabs__content {
    width: 1240px;
    // background: #ffffff;
    // box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
    // border-radius: 0px 0px 48px 48px;
  }
  .coursor_plan_container {
    .tabpane_container_title {
      width: 1240px;
      height: 81px;
      line-height: 81px;
      background: #ffffff;
      box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
      font-size: 24px;

      font-weight: 400;
      color: #666666;
      padding-left: 23px;
      overflow: hidden;
      .container_title_item {
        margin-right: 25px;
        overflow: hidden;
        display: inline-block;
        &:hover {
          cursor: pointer;
          color: #f56057;
        }
      }
      .container_title_item_active {
        color: #f56057;
      }
    }
    .search_line {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 24px 0;
      .container_right_search {
        width: 308px;
        height: 44px;
        /deep/.el-input__inner {
          height: 44px;
          border-radius: 22px;
        }
      }
      .search_line_level {
        width: 105px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        background: #0091ff;
        border-radius: 18px;
        font-size: 14px;
        font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
          "\5FAE\8F6F\96C5\9ED1";
        font-weight: 500;
        color: #ffffff;
        &:hover {
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
    .container_list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      .container_list_item {
        width: 290px;
        height: 242px;
        background: #ffffff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
        border-radius: 10px;
        position: relative;
        overflow: hidden;
        margin-bottom: 30px;
        transition: all 0.2s;
        &:hover {
          cursor: pointer;
          transform: scale(1.01);
        }
        .list_item_pic {
          width: 290px;
          height: 148px;
          // background: pink;
          position: relative;
          .list_item_pic_tag {
            position: absolute;
            top: 0;
            left: 23px;
            width: 56px;
            height: 25px;
            line-height: 25px;
            background: #498805;
            text-align: center;
            font-size: 14px;

            font-weight: 400;
            color: #ffffff;
          }
          img {
            width: 290px;
            height: 148px;
            object-fit: cover;
          }
        }
        .list_item_title {
          width: 100%;
          height: 32px;
          font-size: 18px;
          font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
            "\5FAE\8F6F\96C5\9ED1";
          font-weight: 500;
          color: #000000;
          line-height: 32px;
          margin-top: 5px;
          margin-left: 6px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .list_item_bottom_study {
          margin-left: 8px;
          margin-top: 17px;
          height: 32px;
          font-size: 14px;

          font-weight: 400;
          color: #666666;
          line-height: 32px;
        }
        .list_item_bottom_free {
          width: 68px;
          height: 31px;
          line-height: 31px;
          text-align: center;
          background: linear-gradient(133deg, #fd9d00 0%, #fa6400 100%);
          border-radius: 10px 0px 10px 0px;
          position: absolute;
          right: 0;
          bottom: 0;

          font-size: 18px;
          font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
            "\5FAE\8F6F\96C5\9ED1";
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
  .tabpane_container {
    .htm_content {
      > * {
        margin: 0 auto;
      }
    }
  }
}

/deep/.eltab >>> .el-tabs__header >>> .el-tabs__nav-wrap {
  padding: 0;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll {
  overflow: auto;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav {
  border: none;
  display: flex;
  align-items: flex-end;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .el-tabs__item {
  box-shadow: none;
  width: 230px;
  height: 89px;
  background: #ff8d3a;
  box-shadow: 0px 0px 16px 2px rgba(43, 81, 149, 0.3);
  border-radius: 32px 32px 0px 0px;
  font-size: 24px;
  font-family: "Euclid Flex Bold", Arial, "PingFang SC", Verdana,
    "\5FAE\8F6F\96C5\9ED1";
  font-weight: 500;
  color: #ffffff;
  line-height: 89px;
  text-align: center;
  margin-right: 25px;
  border-left: none;
  margin-right: 16px;
}
/deep/.eltab
  >>> .el-tabs__header
  >>> .el-tabs__nav-wrap
  >>> .el-tabs__nav-scroll
  >>> .el-tabs__nav
  >>> .is-active {
  height: 107px;
  line-height: 127px;
  background: #ffffff;
  color: #333333;
  box-shadow: 0px 0px 16px 2px rgba(0, 0, 0, 0.1);
}
// /deep/.eltab >>> .el-tabs__content {
//   width: 1240px;
//   min-height: 690px;
//   background: #ffffff;
//   box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.1);
//   border-radius: 0px 0px 48px 48px;
// }
/deep/.eltab >>> .el-tabs__header {
  margin: 0;
  border: none;
}
</style>


// WEBPACK FOOTER //
// cmsQualificationsSearch.vue?8bbeaabc